import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {MatSelectChange} from '@angular/material/select';
import {
  FEE_PAYMENT_FILTER_DIALOG_ACTION,
  FeePaymentFilterDialogAction,
  PAYMENT_FILTER_STATUS,
  PaymentFilterStatus
} from '../constants/fee-payment-filter.constants';

export type {PaymentFilterStatus};

export interface PaymentFilterGroupOption {
  id: number;
  name: string;
}

export interface PaymentFilterSubgroupOption {
  id: number;
  name: string;
  groupId: number;
}

export interface FeePaymentFilterValue {
  groupId: number | null;
  subgroupId: number | null;
  periodFrom: Date | null;
  periodTo: Date | null;
  status: PaymentFilterStatus;
}

export interface FeePaymentFilterDialogData {
  groups: PaymentFilterGroupOption[];
  subgroups: PaymentFilterSubgroupOption[];
  current: FeePaymentFilterValue;
}

export interface FeePaymentFilterDialogResult {
  action: FeePaymentFilterDialogAction;
  filters: FeePaymentFilterValue;
}

export const EMPTY_PAYMENT_FILTER_VALUE: FeePaymentFilterValue = {
  groupId: null,
  subgroupId: null,
  periodFrom: null,
  periodTo: null,
  status: PAYMENT_FILTER_STATUS.ALL
};

@Component({
  selector: 'app-fee-payment-filter-dialog',
  templateUrl: './fee-payment-filter-dialog.component.html',
  styleUrl: './fee-payment-filter-dialog.component.scss'
})
export class FeePaymentFilterDialogComponent implements OnInit {
  selectedGroupId: number | null = null;
  selectedSubgroupId: number | null = null;
  periodFrom: Date | null = null;
  periodTo: Date | null = null;
  selectedStatus: PaymentFilterStatus = PAYMENT_FILTER_STATUS.ALL;

  constructor(
    public dialogRef: MatDialogRef<FeePaymentFilterDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: FeePaymentFilterDialogData
  ) {
  }

  ngOnInit(): void {
    const current = this.data.current;
    if (current) {
      this.selectedGroupId = current.groupId ?? null;
      this.selectedSubgroupId = current.subgroupId ?? null;
      this.periodFrom = current.periodFrom ?? null;
      this.periodTo = current.periodTo ?? null;
      this.selectedStatus = current.status ?? PAYMENT_FILTER_STATUS.ALL;
    }
  }

  get availableSubgroups(): PaymentFilterSubgroupOption[] {
    if (this.selectedGroupId === null) {
      return this.data.subgroups;
    }
    return this.data.subgroups.filter(subgroup => subgroup.groupId === this.selectedGroupId);
  }

  onGroupChange(_: MatSelectChange): void {
    if (this.selectedSubgroupId !== null
      && !this.availableSubgroups.some(subgroup => subgroup.id === this.selectedSubgroupId)) {
      this.selectedSubgroupId = null;
    }
  }

  applyFilter(): void {
    const result: FeePaymentFilterDialogResult = {
      action: FEE_PAYMENT_FILTER_DIALOG_ACTION.FILTER,
      filters: {
        groupId: this.selectedGroupId,
        subgroupId: this.selectedSubgroupId,
        periodFrom: this.periodFrom,
        periodTo: this.periodTo,
        status: this.selectedStatus
      }
    };
    this.dialogRef.close(result);
  }

  resetFilters(): void {
    const result: FeePaymentFilterDialogResult = {
      action: FEE_PAYMENT_FILTER_DIALOG_ACTION.RESET,
      filters: {...EMPTY_PAYMENT_FILTER_VALUE}
    };
    this.dialogRef.close(result);
  }

  cancel(): void {
    this.dialogRef.close(null);
  }
}
